<template>
  <div class="acca-share-page">
    <div class="acca-share-wrapper" v-if="acca">
      <div class="acca-share-brand">
        <img src="/img/icons/android-icon-192x192.png" class="acca-share-logo" alt="Betslip Tips" />
        <div>
          <div class="acca-share-brand-name">Betslip Tips</div>
          <div class="acca-share-brand-tag">Data-Driven In-Play Tips</div>
        </div>
      </div>

      <div :class="['acca-share-card', cardStatusClass]">
        <div class="acca-share-header">
          <div>
            <div class="acca-share-title">🎯 Daily Accumulator</div>
            <div class="acca-share-date">{{ formattedDate }}</div>
          </div>
          <div class="acca-share-odds">
            <div class="acca-share-odds-label">{{ hasVoid ? 'Effective Odds' : 'Total Odds' }}</div>
            <div class="acca-share-odds-value">{{ displayOdds }}x</div>
            <div v-if="hasVoid" class="acca-share-odds-was">was {{ acca.totalOdds }} · {{ voidCount }} void</div>
            <div :class="['acca-share-badge', cardStatusClass]">{{ statusLabel }}</div>
          </div>
        </div>

        <div class="acca-share-legs">
          <div
            v-for="leg in acca.legs"
            :key="leg.position"
            class="acca-share-leg"
          >
            <span class="acca-share-leg-icon">{{ legIcon(leg.status) }}</span>
            <div class="acca-share-leg-content">
              <div class="acca-share-leg-teams">{{ leg.homeTeam }} <span class="acca-share-vs">vs</span> {{ leg.awayTeam }}</div>
              <div class="acca-share-leg-market">{{ leg.marketLabel || leg.market }} @ {{ leg.odds }}<span v-if="leg.finalScore"> · final {{ leg.finalScore }}</span></div>
            </div>
          </div>
        </div>

        <div class="acca-share-footer">
          <div class="acca-share-cta">
            <div class="acca-share-cta-row">📲 t.me/betsliptips_free</div>
            <div class="acca-share-cta-row">🌐 portal.betslip.tips</div>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="error" class="acca-share-error">Acca not found</div>
  </div>
</template>

<script>
import axios from "axios";
import format from "date-fns/esm/format";

export default {
  data() {
    return {
      acca: null,
      error: false,
    };
  },
  computed: {
    formattedDate() {
      try { return format(new Date(this.acca.date), "EEEE, MMMM d, yyyy"); }
      catch { return this.acca.date; }
    },
    voidCount() { return (this.acca.legs || []).filter(l => l.status === 3).length; },
    hasVoid() { return this.voidCount > 0 && this.acca.effectiveOdds != null; },
    displayOdds() { return this.hasVoid ? this.acca.effectiveOdds : this.acca.totalOdds; },
    cardStatusClass() {
      if (this.acca.status === 1) return "acca-share-win";
      if (this.acca.status === 2) return "acca-share-loss";
      if (this.acca.status === 3) return "acca-share-partial";
      return "acca-share-pending";
    },
    statusLabel() {
      const map = { 0: "Pending", 1: "Won", 2: "Lost", 3: "Void" };
      return map[this.acca.status] || "Pending";
    },
  },
  async created() {
    const base = window.location.host.indexOf("localhost") !== -1
      ? "http://localhost:5000"
      : "https://portal-api.betslip.tips";
    try {
      const id = this.$route.params.id;
      const { data } = await axios.get(`${base}/api/Accumulator/Public/${id}`);
      this.acca = data;
    } catch (e) {
      this.error = true;
    }
  },
  methods: {
    legIcon(status) {
      if (status === 1) return "✅";
      if (status === 2) return "❌";
      if (status === 3) return "⚪";
      return "⏳";
    },
  },
};
</script>

<style scoped>
.acca-share-page {
  width: 1200px;
  height: 630px;
  background: linear-gradient(135deg, #07255B 0%, #1d3a8a 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  padding: 30px;
  box-sizing: border-box;
}
.acca-share-wrapper {
  width: 100%;
  max-width: 1100px;
}
.acca-share-brand {
  display: flex;
  align-items: center;
  margin-bottom: 18px;
  color: white;
}
.acca-share-logo {
  width: 48px;
  height: 48px;
  border-radius: 10px;
  margin-right: 14px;
}
.acca-share-brand-name {
  font-size: 22px;
  font-weight: bold;
  line-height: 1;
}
.acca-share-brand-tag {
  font-size: 13px;
  color: #FFCF75;
  margin-top: 4px;
}
.acca-share-card {
  background: white;
  border-radius: 24px;
  padding: 28px 36px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  border-top: 8px solid #FFCF75;
}
.acca-share-card.acca-share-win { border-top-color: #1d9c2a; }
.acca-share-card.acca-share-loss { border-top-color: #e50000; }
.acca-share-card.acca-share-partial { border-top-color: #e5680c; }

.acca-share-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 18px;
  padding-bottom: 14px;
  border-bottom: 1px solid #e5e9f2;
}
.acca-share-title { font-size: 28px; font-weight: bold; color: #07255B; }
.acca-share-date { font-size: 15px; color: #888; margin-top: 4px; }
.acca-share-odds { text-align: right; }
.acca-share-odds-label { font-size: 11px; color: #999; text-transform: uppercase; letter-spacing: 0.5px; }
.acca-share-odds-value { font-size: 44px; font-weight: bold; color: #FFCF75; line-height: 1; }
.acca-share-odds-was { font-size: 10px; color: #999; margin-top: 4px; }
.acca-share-badge {
  display: inline-block;
  margin-top: 8px;
  padding: 4px 14px;
  border-radius: 14px;
  color: white;
  font-size: 12px;
  font-weight: bold;
}
.acca-share-badge.acca-share-pending { background: #FFCF75; color: #07255B; }
.acca-share-badge.acca-share-win { background: #1d9c2a; }
.acca-share-badge.acca-share-loss { background: #e50000; }
.acca-share-badge.acca-share-partial { background: #e5680c; }

.acca-share-legs { margin-bottom: 16px; }
.acca-share-leg {
  display: flex;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid #f0f3f9;
}
.acca-share-leg:last-child { border-bottom: none; }
.acca-share-leg-icon { font-size: 18px; margin-right: 12px; width: 24px; flex-shrink: 0; }
.acca-share-leg-content { flex: 1; }
.acca-share-leg-teams { font-size: 16px; font-weight: 600; color: #07255B; }
.acca-share-vs { color: #aaa; font-weight: normal; font-size: 13px; }
.acca-share-leg-market { font-size: 13px; color: #666; margin-top: 2px; }

.acca-share-footer {
  display: flex;
  justify-content: center;
  padding-top: 14px;
  border-top: 1px solid #e5e9f2;
}
.acca-share-cta {
  display: flex;
  gap: 28px;
  color: #07255B;
  font-size: 14px;
  font-weight: 600;
}
.acca-share-cta-row { white-space: nowrap; }
.acca-share-error { color: white; font-size: 24px; }
</style>
